export enum OnlineTerminalModeEnum {
  PaymentPage = 'PaymentPage',
  SelfHostedPage = 'SelfHostedPage',
  MerchantInitiated = 'MerchantInitiated',
}